<div class="container">
    <mat-card class="center mt-5 mb-5">
        <mat-card-title>
            <h2 class="mt-3 mb-4">
                Forgot Password</h2>
        </mat-card-title>

        <mat-card-content>
            <form [formGroup]="forgotForm" (ngSubmit)="forgetPassword()">
                <div class="form-group">
                    <!-- <label for="UserName" class="form-label">Email </label> -->
                    <mat-form-field appearance="outline" class="form-field col-md-offset mb-3" style="width:100%;">
                        <mat-label>Enter your email</mat-label>
                        <input matInput formControlName="UserName" name="UserName" id="UserName"
                            [ngClass]="{ 'is-invalid': submitted && forms.UserName.errors }" required autofocus />
                        <mat-error *ngIf="submitted && forms.UserName.errors" class="invalid-feedback">
                            <div *ngIf="forms.UserName.errors.required">Email is required</div>
                            <div *ngIf="forms.UserName.errors.email">Email must be a valid email address
                            </div>
                        </mat-error>
                    </mat-form-field>
                </div>
                <alert></alert>
                <button type="submit" class="btn btn-primary d-grid w-100 mb-3">Send Link</button>
                <button class="btn btn-primary d-grid w-100 mb-3" [routerLink]="'/signin'">Cancel</button>
            </form>
        </mat-card-content>
    </mat-card>
</div>